import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import Badge from "../../../components/Common/Badge";
import PropTypes from "prop-types";

function MensagensDataTable({ linhas, togMensagemModal, apagaMensagem }) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome da função",
        accessor: "titulo",
        isSorted: true,
      },
      {
        Header: "Status",
        Cell: ({ row }) => {
          let status = [];
          if (row.original.ativo === "1") {
            status.push(
              <div>
                <Badge color="success">Ativo</Badge>
              </div>
            );
          } else {
            status.push(
              <div>
                <Badge color="danger">Inativo</Badge>
              </div>
            );
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        largura: "150px",
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`editar-${row.original.titulo}`}
                onClick={() => {
                  togMensagemModal(row.original.titulo);
                }}
                color="success"
                icon="mdi mdi-account-edit"
              >
                Editar
              </DropdownButton>
              <DropdownButton
                key={`alterar-status-${row.original.titulo}`}
                onClick={() => {
                  apagaMensagem(
                    row.original.titulo,
                    row.original.ativo === "1" ? "0" : "1"
                  );
                }}
                color={row.original.ativo === "1" ? "danger" : "success"}
                icon={
                  row.original.ativo === "1"
                    ? "mdi mdi-trash-can"
                    : "mdi mdi-delete-restore"
                }
              >
                {row.original.ativo === "1" ? "Desativar" : "Ativar"}
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [apagaMensagem, togMensagemModal]
  );

  return <CommonDataTable colunas={colunas} linhas={linhas} />;
}

MensagensDataTable.propTypes = {
  linhas: PropTypes.arrayOf(
    PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      ativo: PropTypes.string.isRequired,
    })
  ).isRequired,
  togMensagemModal: PropTypes.func.isRequired,
  apagaMensagem: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default MensagensDataTable;
